export const PunishActionEditorPlaceholdersKey = Symbol()
export const PunishActionEditorButtonsKey = Symbol()
export const PunishActionEditorPrefix = Symbol()
